import React from "react";
import Chart from "react-google-charts";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

export const ChartCardComponent = (props) => {
    return (
        <div className="ibox">
            <div className="ibox-title">
                <h4>{props.title}</h4>
                <small className={"d-block"}>{props.subtitle}</small>
            </div>
            <div className="ibox-content">
                <div className={"card-body text-center"}>
                    {
                        props.data.length > 2
                            ? <Chart
                                height={props.height}
                                chartType={props.chartType}
                                loader={<div style={{minHeight: "100%"}}
                                             className={'d-flex align-items-center justify-content-center'}>
                                    <CircularProgress/></div>}
                                options={{
                                    chartArea: {width: '80%'},
                                    legend: {position: 'right', alignment: 'left'},
                                    pieHole: 0.3
                                }}
                                chartEvents={[
                                    {
                                        eventName: "select",
                                        callback: ({chartWrapper}) => {
                                            const eventParams = chartWrapper.getChart().getSelection()[0];
                                            if (props.clicked)
                                                props.clicked(eventParams.row);
                                        }
                                    }
                                ]}
                                data={props.data}
                            />
                            : <div style={{minHeight: props.height}}>
                                <h3>No data available</h3>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
